export const SidebarDivider = () => (
  <div className="w-full px-2 py-1">
    <hr className="border-gray-150 dark:border-gray-800" />
  </div>
)
